import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  TextField,
  IconButton,
  Select,
  MenuItem,
  Checkbox,
  Modal,
  Skeleton,
  InputAdornment,
  Tooltip,
  FormControl,
  InputLabel,
} from "@mui/material";
import { headingStyle, tableRowLab } from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import { primaryBtn } from "../../style/AppointmentStyle";
import {
  autoFocusOffWithOutBorder,
  drTableRowBlueBg,
} from "../../style/PatinetFormStyle";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import updownar from "../../assets/updownar.svg";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CustomModal from "../CustomModal/CustomModal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import EditMedicines from "./EditMedicines";
import NewMedicines from "./NewMedicines";
import MedicineImageUpload from "../Prescription/AdminShortCuts/MedicineScanUpload/MedicineImageUpload";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import medicines_icon from "../../assets/medicine.svg";
import MedicinesDetails from "./MedicinesDetails";
import UseFetchMedicineAdmin from "../../helper/UseFetchMedicineAdmin";
import { primaryBtnTeal } from "../../style/PatientDetailsStyle";
import { Link, useNavigate } from "react-router-dom";
import { formattedDate } from "../../utils/constantFunctions";
import { showToast } from "../../utils/toastUtil";
import { exportStockReport } from "../../utils/stockReportExport";
import { deleteMedicine } from "../../connections/deleteApi";
import SearchIcon from "@mui/icons-material/Search";
import useDebounce from "../../hooks/UseDebounce";

const Medicines = ({ onClose }) => {
  // console.log(medicines);
  const navigate = useNavigate();

  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [editPurchaseOrderModal, setEditPurchaseOrderModal] = useState(false);
  const [newPurchaseOrderModal, setNewPurchaseOrderModal] = useState(false);
  const [uploadImage, setImageUpload] = useState(false);
  const [page, setPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [id, setId] = useState(null);
  const [editId, setEditId] = useState(null);
  const [goToPage, setGoToPage] = useState("");
  const [medicineSearchInput, setMedicineSearchInput] = useState(null);
  const [stockReportProgress, setStockReportProgress] = useState(null);

  const handleStockReport = async () => {
    if (stockReportProgress) return;
    try {
      setStockReportProgress("Preparing…");
      const count = await exportStockReport(setStockReportProgress);
      showToast(`Stock report exported (${count} medicines)`, "SUCCESS");
    } catch (e) {
      showToast("Stock report export failed", "ERROR");
    } finally {
      setStockReportProgress(null);
    }
  };

  //  console.log(medicineList?.payload?.medicines);
  const handleMedicineChange = (e) => {
    e.preventDefault();
    setMedicineSearchInput(e?.target?.value);
  };

  const debouncedInputMedicine = useDebounce(medicineSearchInput, 1000);

  const {
    data: medicineList,
    refetch,
    isLoading,
  } = UseFetchMedicineAdmin(page, itemPerPage, debouncedInputMedicine);

  const totalRecords = medicineList?.meta?.total_count || 0;
  const totalPage = Math.ceil(totalRecords / itemPerPage);

  const handlePrevious = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < totalPage) setPage((prev) => prev + 1);
  };

  // useEffect(() => {
  //   refetch(page, itemPerPage)
  // }, [page, itemPerPage ]);

  const handleDelete = async (id) => {
    setDeleteModal(false);
    const res = await deleteMedicine(id);
    //  console.log(res);

    showToast(res?.status?.message || res?.status?.status, res?.status?.status);
    if (res?.status?.status) {
      refetch(page, itemPerPage);
    }
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          height: "90vh",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* //modals for delete and filter */}
        <Modal
          open={deleteModal}
          onClose={() => setDeleteModal(false)}
          sx={{
            position: "absolute",
            top: "25%",
            // left:'50%',
            width: "450px",
            // height:"400px",
            margin: "auto",
            //  display: "flex",
            //  alignItems: "flex-start",
            //  justifyContent: "center",
            //  overflow: "auto",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "background.paper",
              borderRadius: 3.6,
              boxShadow: 24,
              p: 4.5,
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography textAlign={"center"}>Are you sure?</Typography>
              <Typography textAlign={"center"}>
                You want to delete these selected purchase orders?
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "flex",
                gap: "25px",
                width: "max-content",
                margin: "auto",
                marginTop: "40px",
              }}
            >
              <Button
                onClick={() => handleDelete(id)}
                sx={{
                  backgroundColor: "#FF392B",
                  color: "white",
                  border: "",
                  width: "150px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: "red",
                  },
                }}
              >
                Delete
              </Button>
              <Button
                onClick={() => setDeleteModal(false)}
                sx={{
                  backgroundColor: "white",
                  color: "black",
                  border: "2px solid #FF392B",
                  width: "150px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  textTransform: "capitalize",
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={filterModal}
          onClose={() => setFilterModal(false)}
          sx={{
            position: "absolute",
            top: "14%",
            // left:'50%',
            width: "340px",
            // height:"400px",
            margin: "auto",
            //  display: "flex",
            //  alignItems: "flex-start",
            //  justifyContent: "center",
            //  overflow: "auto",
            borderRadius: "20px",
          }}
        >
          <Box
            sx={{
              mt: 2,
              bgcolor: "background.paper",
              borderRadius: "20px",
              boxShadow: 24,
              p: 1,
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <Grid container spacing={2} sx={{ padding: "9px" }}>
              <Grid item xs={12}>
                <Typography
                  variant="subTitle116px"
                  fontWeight={"600"}
                  textAlign={"center"}
                  margin={"auto"}
                >
                  Filters
                </Typography>
              </Grid>

              {/* <Grid item xs={12}>
        <Typography  variant="subTitle116px" >Suppliers</Typography>
      </Grid> */}

              {/* Filter Selection */}
              <Grid item xs={12}>
                <Select
                  fullWidth
                  defaultValue=""
                  placeholder="Select Filter"
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "neutral.blueShadeBg",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <span style={{ color: "text.default_grey" }}>
                          Select filter
                        </span>
                      );
                    }
                    return selected === "filter1"
                      ? "filter2"
                      : selected === "filter3"
                        ? "filter3"
                        : "select filter";
                  }}
                >
                  <MenuItem value="filter1">Filter 1</MenuItem>
                  <MenuItem value="filter2">Filter 2</MenuItem>
                  <MenuItem value="filter3">Filter 3</MenuItem>
                </Select>
              </Grid>

              {/* Purchase Date */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Purchase Date</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="From"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="To"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Department Selection */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Department</Typography>
                <Select
                  fullWidth
                  defaultValue=""
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "neutral.blueShadeBg",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <MenuItem value="dept1">Department 1</MenuItem>
                  <MenuItem value="dept2">Department 2</MenuItem>
                  <MenuItem value="dept3">Department 3</MenuItem>
                </Select>
              </Grid>

              {/* Created At */}
              <Grid item xs={12}>
                <Typography variant="subTitle116px">Created At</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="From"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  sx={autoFocusOffWithOutBorder}
                  label="To"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Buttons */}
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="subTitle116px16px"
                  sx={{ ...primaryBtnTeal, color: "white" }}
                >
                  Apply
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={() => setFilterModal(false)}
                  fullWidth
                  variant="subTitle116px16px"
                  sx={{ ...primaryBtn, color: "white", border: "none" }}
                >
                  Clear Filters
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
            mb={1}
          >
            <Box></Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src={medicines_icon}
                alt=""
                sx={{
                  color: "neutral.navyBlue",
                  marginBottom: "4px",
                  marginRight: "8px",
                }}
              />
              <Typography
                variant="heading_Large"
                fontWeight={700}
                gutterBottom
                sx={headingStyle}
              >
                Medicines
              </Typography>
            </Box>
            <IconButton sx={{ marginBottom: "r0em" }} onClick={onClose}>
              <CloseIcon size="small" sx={{ color: "red" }} />
            </IconButton>
          </Box>

          <Box
            mt={-1}
            mb={-1}
            marginLeft={-1}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            position="sticky"
            paddingX="25px"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                gap: 2,
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <AddRoundedIcon
                  onClick={() => setNewPurchaseOrderModal(true)}
                  sx={{
                    backgroundColor: "#FFE7DC",
                    p: "4px",
                    width: "20px",
                    color: "#FF8D1E",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                />
                <CameraAltOutlinedIcon
                  onClick={() => setImageUpload(true)}
                  sx={{
                    backgroundColor: "#E0F4F7",
                    p: "4px",
                    width: "20px",
                    color: "#0097B2",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                />
              </Box>
              {/* <Box > <AddRoundedIcon onClick={()=>setNewPurchaseOrderModal(true)} sx={{backgroundColor:"#FFE7DC" ,p:'4px',  width:"20px", color:"#FF8D1E" , borderRadius:"8px" ,cursor:"pointer"}}   /></Box> */}

              <Box>
                <TextField
                  sx={{ ...autoFocusOffWithOutBorder }}
                  type="text"
                  className="form-control"
                  placeholder="Search Medicine "
                  value={medicineSearchInput}
                  onChange={handleMedicineChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>

            <Box
              onClick={() => setFilterModal(true)}
              sx={{
                display: "flex",
                alignItems: "center",
                marginRight: "20px",
              }}
            >
              {/* <IconButton  >
          <TuneRoundedIcon size="small"  sx={{color:"#0067FF"}}/>  
        </IconButton>
        <Typography>
         Filters
        </Typography>  */}
            </Box>
          </Box>

          <Grid item xs={12}>
            <TableContainer sx={{ mt: 2, width: "100%" }}>
              <Table sx={{ width: "100%" }}>
                <TableHead stickyHeader>
                  <TableRow sx={{ textAlign: "center" }}>
                    {/* <TableCell
                variant="body1_text_bold" 
                  sx={{
                    borderTopLeftRadius:"20px",
                    
                  color: 'neutral.black',
                    p: "6px", 
                    textAlign: "center",
                  }} 
                > 
                  <Checkbox/>
                </TableCell> */}

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      ID
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "6px",

                        //  paddingX:"4px",
                        textAlign: "center",
                        width: "200px",
                      }}
                    >
                      Name
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        width: "130px",
                        paddingRight: "30px",
                        color: "neutral.black",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Company
                    </TableCell>
                    {/* <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Amount (Flat Price)
                    </TableCell> */}
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Discount
                    </TableCell>

                    {/* <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: 'neutral.black',
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Packing
                    </TableCell> */}

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Stock left
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Expiry
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Form Type
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Medicine Salt
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>

                {isLoading ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={12} sx={{ p: 0 }}>
                        <Box
                          sx={{
                            rowGap: 1.2,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />

                          <Skeleton
                            variant="rectangular"
                            sx={{
                              width: "100%",
                              height: "50px", // Adjust to match your table row height
                              backgroundColor: "#f0f0f0", // Light grey color
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {medicineList?.payload?.medicines?.map(
                      (medicine, index) => (
                        <TableRow
                          sx={{
                            ...tableRowLab,
                            textAlign: "center",
                            backgroundColor: "neutral.blueShadeBg",
                            borderBottom: "8px solid white",
                            borderTop:
                              index === 0
                                ? "4px solid white"
                                : "2px solid white",
                          }}
                        >
                          {/* <TableCell
                variant="subTitle116px" 
                  sx={{
                    borderTopLeftRadius:"20px",
                    borderBottomLeftRadius:"20px",
                  color: 'neutral.black',
                    p: "6px", 
                    textAlign: "center",
                  }}
                > 
                  <Checkbox/> 
                </TableCell> */}
                          <TableCell
                            sx={{
                              borderTopLeftRadius: "20px",
                              borderBottomLeftRadius: "20px",
                              color: "neutral.black",
                              p: "6px",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              variant="subTitle116px"
                              sx={{ color: "#3A3A3A" }}
                            >
                              {" "}
                              {medicine?.id}{" "}
                            </Typography>
                          </TableCell>
                          <TableCell
                            variant="body1_text_bold"
                            sx={{
                              color: "neutral.black",
                              p: "6px",
                              //  paddingX:"4px",
                              textAlign: "center",
                              width: "200px",
                            }}
                          >
                            {/* <Link> */}

                            <Tooltip
                              title={medicine?.name}
                              arrow
                              onClick={() => {
                                setDetailsModal(true);
                                setId(medicine?.id);
                              }}
                            >
                              <Typography
                                variant="subTitle116px"
                                sx={{
                                  color: "#0067FF",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: 180, // set max width as needed
                                  cursor: "pointer",
                                  display: "inline-block",
                                }}
                              >
                                {medicine?.name}
                              </Typography>
                            </Tooltip>
                            {/* </Link> */}
                          </TableCell>

                          <TableCell
                            variant="body1_text_bold"
                            sx={{
                              width: "130px",
                              paddingRight: "30px",
                              color: "neutral.black",
                              p: "6px",
                              textAlign: "center",
                            }}
                          >
                            <Box
                              sx={{ display: "flex", flexDirection: "column" }}
                            >
                              <Tooltip title={medicine?.company} arrow>
                                <Typography
                                  variant="subTitle116px"
                                  sx={{
                                    color: "#3A3A3A",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: 150, // set max width as needed
                                    cursor: "pointer",
                                    display: "inline-block",
                                  }}
                                >
                                  {medicine?.company}
                                </Typography>
                              </Tooltip>
                            </Box>
                          </TableCell>
                          {/* <TableCell
                            variant="body1_text_bold"
                            sx={{
                              color: "neutral.black",
                              p: "6px",
                              textAlign: "center",
                            }}
                          >
                            <Box
                              sx={{ display: "flex", flexDirection: "column" }}
                            >
                              {medicine?.flat_price ? (
                                <Typography
                                  variant="subTitle116px"
                                  sx={{ color: "#3A3A3A" }}
                                >
                                  <Typography
                                    variant="span"
                                    sx={{ color: "#3A3A3A" }}
                                  >
                                    {" "}
                                    &#8377;{" "}
                                  </Typography>
                                  {medicine?.flat_price}
                                </Typography>
                              ) : (
                                <Typography
                                  variant="span"
                                  sx={{ color: "#3A3A3A" }}
                                >
                                  N/A
                                </Typography>
                              )}
                            </Box>
                          </TableCell> */}
                          <TableCell
                            variant="body1_text_bold"
                            sx={{
                              color: "neutral.black",
                              p: "6px",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              variant="subTitle116px"
                              sx={{ color: "#3A3A3A" }}
                            >
                              {medicine?.discount}
                            </Typography>
                          </TableCell>

                          {/* <TableCell
                            variant="body1_text_bold"
                            sx={{
                              color: 'neutral.black',
                              p: "6px",
                              textAlign: "center",
                            }}
                          >
                            <Typography variant="subTitle116px">  {medicine?.packing}  </Typography>
                          </TableCell> */}

                          <TableCell
                            variant="body1_text_bold"
                            sx={{
                              color: "neutral.black",
                              p: "6px",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              variant="subTitle116px"
                              sx={{ color: "#3A3A3A" }}
                            >
                              {" "}
                              {medicine?.total_stock_left}{" "}
                            </Typography>
                          </TableCell>

                          <TableCell
                            variant="body1_text_bold"
                            sx={{
                              color: "neutral.black",
                              p: "6px",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              variant="subTitle116px"
                              sx={{ color: "#3A3A3A" }}
                            >
                              {" "}
                              {formattedDate(medicine?.expiry_date)}{" "}
                            </Typography>
                          </TableCell>

                          <TableCell
                            variant="body1_text_bold"
                            sx={{
                              color: "neutral.black",
                              p: "6px",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              variant="subTitle116px"
                              sx={{ color: "#3A3A3A" }}
                            >
                              {" "}
                              {medicine?.form_type}
                            </Typography>
                          </TableCell>

                          <TableCell
                            variant="body1_text_bold"
                            sx={{
                              color: "neutral.black",
                              p: "6px",
                              textAlign: "center",
                            }}
                          >
                            {/* <Link>   */}
                            {/* <Typography variant="subTitle116px" sx={{ color: "#3A3A3A" }}> {medicine?.medicine_salt?.name} </Typography> */}
                            {/* </Link> */}
                            <Tooltip
                              title={medicine?.medicine_salt?.name}
                              arrow
                            >
                              <Typography
                                variant="subTitle116px"
                                sx={{
                                  color: "#3A3A3A",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: 180, // set max width as needed
                                  cursor: "pointer",
                                  display: "inline-block",
                                }}
                              >
                                {medicine?.medicine_salt?.name}
                              </Typography>
                            </Tooltip>
                          </TableCell>

                          <TableCell
                            sx={{
                              borderTopRightRadius: "20px",
                              borderBottomRightRadius: "20px",
                              // justifyContent: 'center'
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                gap: "8px",
                                marginRight: "-14px",
                              }}
                            >
                              <RemoveRedEyeOutlinedIcon
                                onClick={() => {
                                  setDetailsModal(true);
                                  setId(medicine?.id);
                                }}
                                sx={{
                                  backgroundColor: "#0067FF",
                                  p: "4px",
                                  width: "18px",
                                  color: "white",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                              />

                              <EditOutlinedIcon
                                onClick={() => {
                                  setEditId(medicine?.id);
                                  setEditPurchaseOrderModal(true);
                                }}
                                sx={{
                                  backgroundColor: "#FF8D1E",
                                  p: "4px",
                                  width: "18px",
                                  color: "white",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                              />
                            </Box>
                          </TableCell>
                        </TableRow>
                      ),
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Grid>
        </Box>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={1}
          sx={{ zIndex: 10, mb: "5px" }}
        >
          {/* Stock report export — left */}
          <Button
            onClick={handleStockReport}
            disabled={Boolean(stockReportProgress)}
            variant="contained"
            sx={primaryBtnTeal}
          >
            {stockReportProgress || "Stock Report (CSV)"}
          </Button>

          {/* Pagination — right side */}
          <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
            {/* Previous */}
            <Button
              onClick={handlePrevious}
              disabled={page === 1}
              startIcon={<ArrowBackIcon sx={{ fontSize: "14px" }} />}
              sx={{ fontSize: "12px", textTransform: "none", color: page === 1 ? "#9e9e9e" : "#007A99", "&:disabled": { color: "#9e9e9e" } }}
            >
              Prev
            </Button>

            {/* Windowed page numbers */}
            {(() => {
              if (totalPage <= 7) return [...Array(totalPage)].map((_, i) => i + 1);
              const pages = [];
              pages.push(1);
              if (page > 3) pages.push("...");
              for (let p = Math.max(2, page - 1); p <= Math.min(totalPage - 1, page + 1); p++) pages.push(p);
              if (page < totalPage - 2) pages.push("...");
              pages.push(totalPage);
              return pages;
            })().map((p, i) =>
              p === "..." ? (
                <Typography key={`ellipsis-${i}`} sx={{ fontSize: "12px", px: "4px", color: "#999" }}>…</Typography>
              ) : (
                <Button
                  key={p}
                  onClick={() => setPage(p)}
                  sx={{
                    minWidth: "30px", height: "30px", fontSize: "12px", borderRadius: "6px", p: "2px",
                    color: page === p ? "#fff" : "#333",
                    backgroundColor: page === p ? "#007A99" : "#fff",
                    border: "1px solid #d0d0d0",
                    "&:hover": { backgroundColor: page === p ? "#007A99" : "#f2f2f2" },
                  }}
                >
                  {p}
                </Button>
              )
            )}

            {/* Next */}
            <Button
              onClick={handleNext}
              disabled={page === totalPage || totalPage === 0}
              endIcon={<ArrowForwardIcon sx={{ fontSize: "14px" }} />}
              sx={{ fontSize: "12px", textTransform: "none", color: (page === totalPage || totalPage === 0) ? "#9e9e9e" : "#007A99", "&:disabled": { color: "#9e9e9e" } }}
            >
              Next
            </Button>

            {/* Go to page */}
            <Box display="flex" alignItems="center" gap="4px">
              <Typography sx={{ fontSize: "12px", color: "#555" }}>Go to</Typography>
              <TextField
                size="small"
                type="number"
                value={goToPage}
                onChange={(e) => setGoToPage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const n = parseInt(goToPage, 10);
                    if (n >= 1 && n <= totalPage) { setPage(n); setGoToPage(""); }
                  }
                }}
                sx={{ width: "60px", "& input": { fontSize: "12px", padding: "6px 8px" }, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
              />
            </Box>

            {/* Rows per page */}
            <FormControl size="small" sx={{ minWidth: 80 }}>
              <InputLabel sx={{ fontSize: "12px" }}>Rows</InputLabel>
              <Select
                value={itemPerPage}
                label="Rows"
                onChange={(e) => { setItemPerPage(e.target.value); setPage(1); }}
                sx={{ fontSize: "12px", borderRadius: "8px" }}
              >
                {[10, 20, 50, 100].map((n) => (
                  <MenuItem key={n} value={n} sx={{ fontSize: "12px" }}>{n}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%" }}
        open={detailsModal}
        setDetailsModal
        onClose={() => setDetailsModal(false)}
      >
        <MedicinesDetails
          onClose={() => setDetailsModal(false)}
          id={id}
          refetch={refetch}
          page={page}
          itemPerPage={itemPerPage}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "90%" }}
        open={editPurchaseOrderModal}
        onClose={() => setEditPurchaseOrderModal(false)}
      >
        <EditMedicines
          onClose={() => setEditPurchaseOrderModal(false)}
          refetch={refetch}
          page={page}
          itemPerPage={itemPerPage}
          id={editId}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "90%" }}
        open={newPurchaseOrderModal}
        onClose={() => setNewPurchaseOrderModal(false)}
      >
        <NewMedicines
          onClose={() => setNewPurchaseOrderModal(false)}
          refetch={refetch}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", width: "85%", marginTop: "20px" }}
        open={uploadImage}
        onClose={() => setImageUpload(false)}
      >
        <MedicineImageUpload
          onClose={() => {
            setImageUpload(false);
            refetch();
          }}
        />
      </CustomModal>
    </>
  );
};

export default Medicines;
